import { Component, ViewChild } from "@angular/core";
import { AuthService } from "./services/auth.service";
import {  Router } from "@angular/router";
import { SigmentsService } from "./services/sigments.service";
import { MatSidenav } from "@angular/material";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent  {
  @ViewChild("stepFourSidenav", { static: false })
  public stepFourSidenav: MatSidenav;
  orgList: any;
  isPowerUser: boolean;
  selectedOrg: any;
  orgName: any;
  filter:any;
  constructor(
    public service: AuthService,
    private router: Router,
    private sigmentsSrv: SigmentsService
  ) {
    this.service.GetUser();
  }

  gotoDashboard(){
      this.router.navigate(["/home/dashboard"]);
    //this.router.navigate(["/dashboard"]);
  }
  ngOnInit() {
    this.service.GetUser();
    this.sigmentsSrv.change.subscribe((orgName) => {
      this.orgName = orgName;
      this.SetOrgForPowerUser(this.orgName);
      this.sigmentsSrv.getIsPoweUser().then((isPowerUser) => {
        this.isPowerUser = isPowerUser;
        if (this.isPowerUser) {
          this.sigmentsSrv.getOrgList().then((orgList) => {
           //this.selectedOrg = orgList[0];
          // orgList.splice(0, 1);
            this.orgList = orgList;
            if(orgList.length>0)
              this.selectedOrg = orgList.filter(o=>o.Name == this.orgName)[0].CRM ;
          });
        }
      });
    });
  }
  gotoReports() {
    //window.open("https://reoprts360.firebaseapp.com/home", "_blank");
    this.router.navigate(["/home/reports"]);
  }
  gotoBooking(){
    this.router.navigate(["/home/booking"]);
  }
  gotoArchive(){
    this.router.navigate(["/home/Archive"]);
  }
  SetOrgForPowerUser(org) {
    this.sigmentsSrv.setPowerUserOrg(org).then((success) => {
      if (success) {
       this.router.navigate(["/"]);
       setTimeout(()=>{  this.router.navigate(["/home/dashboard"]); },500);
      
        this.sigmentsSrv.getIsPoweUser().then((isPowerUser) => {
          this.isPowerUser = isPowerUser;
          if (this.isPowerUser) {
            this.sigmentsSrv.getOrgList().then((orgList) => {
              this.orgList = orgList;
            });
          }
        });
      }
    });
  }
  LogOut() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("expiredDate");
    this.router.navigate(["/login"]);
  }
}
